
function Footer() {

return (
<footer className="bg-gray-900 text-white py-6">
<div className="text-center">
  <p className='backdrop-blur-sm'>&copy; 2024 Challenge Game. Todos os direitos reservados.</p>
</div>
</footer>
);

};

export default Footer;